import { CountdownTimerLabels } from "./types";

export const defaultLabels: CountdownTimerLabels = {
  days: (count) => (count === 1 ? "Day" : "Days"),
  hours: (count) => (count === 1 ? "Hour" : "Hours"),
  minutes: (count) => (count === 1 ? "Minute" : "Minutes"),
  seconds: (count) => (count === 1 ? "Second" : "Seconds"),
  expired: "Countdown expired",
  timeRemaining: ({
    days,
    daysLabel,
    hours,
    hoursLabel,
    minutes,
    minutesLabel,
    seconds,
    secondsLabel,
  }) =>
    `Time remaining: ${days} ${daysLabel}, ${hours} ${hoursLabel}, ${minutes} ${minutesLabel}, ${seconds} ${secondsLabel}`,
  deadlineAt: (formatted) => `Deadline at ${formatted}`,
};

export const formatTime = (value: number) => String(value).padStart(2, "0");

export const unitKeys = ["days", "hours", "minutes", "seconds"] as const;
